export var ActionType;
(function (ActionType) {
    ActionType["BUY"] = "buy";
    ActionType["SELL"] = "sell";
    ActionType["LONG"] = "long";
    ActionType["SHORT"] = "short";
})(ActionType || (ActionType = {}));
export var MarketType;
(function (MarketType) {
    MarketType["SPOT"] = "spot";
    MarketType["PERP"] = "perp";
    MarketType["PREDICTION_MARKET"] = "prediction_market";
})(MarketType || (MarketType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
})(SortOrder || (SortOrder = {}));
export var OddsFormat;
(function (OddsFormat) {
    OddsFormat["American"] = "american";
    OddsFormat["Percent"] = "percent";
    OddsFormat["Price"] = "price";
})(OddsFormat || (OddsFormat = {}));
export const ODDS_FORMAT_LABELS = {
    [OddsFormat.American]: "American",
    [OddsFormat.Percent]: "Percent",
    [OddsFormat.Price]: "Price",
};
export const ODDS_FORMAT_EXAMPLES = {
    [OddsFormat.American]: "+150",
    [OddsFormat.Percent]: "40%",
    [OddsFormat.Price]: "40¢",
};
export var PaymentActionType;
(function (PaymentActionType) {
    PaymentActionType["DEPOSIT"] = "deposit";
    PaymentActionType["SEND"] = "send";
    PaymentActionType["RECEIVE"] = "receive";
    PaymentActionType["WITHDRAW"] = "withdraw";
    PaymentActionType["SPEND"] = "spend";
})(PaymentActionType || (PaymentActionType = {}));
/** Chart timeframe selector values (Bullrun web + mobile). */
export var Timeframe;
(function (Timeframe) {
    Timeframe["FIVE_MINUTES"] = "5M";
    Timeframe["ONE_HOUR"] = "1H";
    Timeframe["FOUR_HOURS"] = "4H";
    Timeframe["ONE_DAY"] = "1D";
    Timeframe["ONE_WEEK"] = "1W";
    Timeframe["ONE_MONTH"] = "1M";
    Timeframe["SIX_MONTHS"] = "6M";
    Timeframe["ONE_YEAR"] = "1Y";
    Timeframe["MAX"] = "Max";
    Timeframe["ALL"] = "All";
    Timeframe["ALTER_CHART"] = "alter_chart";
    Timeframe["SHOW_OPTIONS"] = "show_options";
})(Timeframe || (Timeframe = {}));
/** Line vs candlestick mode for Bullrun price charts (web + mobile). */
export var ChartType;
(function (ChartType) {
    ChartType["CANDLESTICK"] = "candlestick";
    ChartType["LINE"] = "line";
})(ChartType || (ChartType = {}));
